<template>
    <div class="container">
        <div id="estimate">
            <div>
                <div>
                    <div v-html="$t('message.devis_intro1')" class="main-title"></div>
                    <div v-html="$t('message.devis_intro2')"></div>
                    <div v-html="$t('message.devis_intro3')"></div>
                    <div v-html="$t('message.devis_intro4')"></div>
                    <span><span>*</span> {{ $t("message.devis_info_required") }}</span>
                </div>

                <form id="form-estimate" @submit.prevent="sendEstimate">
                    <div class="input-group required">
                        <label for="name">{{ $t("message.your_name") }}</label>
                        <input id="name" type="text" v-model="name" required class="field" />
                    </div>
                    <div class="input-group required">
                        <label for="email">{{ $t("message.devis_label_email") }}</label>
                        <input id="email" type="text" v-model="email" required class="field" />
                    </div>
                    <div class="input-group">
                        <label for="phone">{{ $t("message.devis_label_tel") }}</label>
                        <input id="phone" type="tel" v-model="phone" class="field" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_project") }}</div>

                    <div class="input-group required">
                        <label for="project-title">{{ $t("message.devis_label_title") }}</label>
                        <input id="project-title" type="text" v-model="title" required class="field" />
                    </div>
                    <div class="input-group required">
                        <label for="duration">{{ $t("message.devis_label_duration") }}</label>
                        <input id="duration" type="number" v-model="duration" required class="field" min="0" />
                    </div>
                    <div class="input-group">
                        <label for="objective">{{ $t("message.devis_label_objective") }}</label>
                        <input id="objective" type="text" v-model="objective" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="target">{{ $t("message.devis_label_target") }}</label>
                        <input id="target" type="text" v-model="target" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="modality">{{ $t("message.devis_label_modality") }}</label>
                        <input id="modality" type="text" v-model="modality" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="people-targeted">{{ $t("message.devis_label_number_people_targeted") }}</label>
                        <input id="people-targeted" type="text" v-model="people_targeted" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="delivery-method">{{ $t("message.devis_label_delivery_method") }}</label>
                        <input id="delivery-method" type="text" v-model="delivery_method" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="start-date">{{ $t("message.devis_label_launch_date") }}</label>
                        <input id="start-date" type="date" v-model="start_date" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="number-of-modules">{{ $t("message.devis_label_number_of_modules") }}</label>
                        <input id="number-of-modules" type="text" v-model="number_of_modules" class="field" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_languages_and_sounds") }}</div>

                    <div class="input-group required">
                        <label for="initial-language">{{ $t("message.devis_label_init_lang") }}</label>
                        <select id="initial-language" v-model="language" required>
                            <option></option>
                            <option :value="$t('message.devis_language_fr')">{{ $t("message.devis_language_fr") }}</option>
                            <option :value="$t('message.devis_language_en')">{{ $t("message.devis_language_en") }}</option>
                            <option :value="$t('message.devis_language_other')">{{ $t("message.devis_language_other") }}</option>
                        </select>
                    </div>
                    <div class="input-group required">
                        <label for="additional-language">{{ $t("message.devis_label_additional_lang") }}</label>
                        <input id="additional-language" type="text" v-model="additional_language" required class="field" />
                    </div>
                    <div class="input-group">
                        <span>{{ $t("message.devis_label_voiceover") }}</span>
                        <div class="chk">
                            <label>
                                <input type="radio" name="voiceover" value="oui" />
                                <span>{{ $t("message.yes") }}</span>
                            </label>
                            <label>
                                <input type="radio" name="voiceover" value="non" checked="checked" />
                                <span>{{ $t("message.no") }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="input-group">
                        <span>{{ $t("message.devis_label_video") }}</span>
                        <div class="chk">
                            <label>
                                <input type="radio" name="video" value="oui" />
                                <span>{{ $t("message.yes") }}</span>
                            </label>
                            <label>
                                <input type="radio" name="video" value="non" checked="checked" />
                                <span>{{ $t("message.no") }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="input-group">
                        <label for="needs">{{ $t("message.devis_label_needs_video") }}</label>
                        <input id="needs" type="text" v-model="needs" class="field" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_file") }}</div>
                    <div v-html="$t('message.devis_label_file_intro')" class="info"></div>
                    <div class="input-group">
                        <input id="file" type="file" name="file" accept=".docx,.doc,.ppt,.pptx,.pdf,.dox" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_technical") }}</div>
                    <div class="input-group">
                        <label for="technical">{{ $t("message.devis_label_technical") }}</label>
                        <input id="technical" type="text" v-model="technical" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="supports">{{ $t("message.devis_label_supports") }}</label>
                        <input id="supports" type="text" v-model="supports" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="browsers">{{ $t("message.devis_label_browsers") }}</label>
                        <input id="browsers" type="text" v-model="browsers" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="others">{{ $t("message.devis_label_others") }}</label>
                        <input id="others" type="text" v-model="others" class="field" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_production") }}</div>
                    <div class="input-group required">
                        <label for="level">{{ $t("message.devis_label_level") }}</label>
                        <select id="level" v-model="level" required>
                            <option></option>
                            <option :value="$t('message.devis_production_opt1')">{{ $t("message.devis_production_opt1") }}</option>
                            <option :value="$t('message.devis_production_opt2')">{{ $t("message.devis_production_opt2") }}</option>
                            <option :value="$t('message.devis_production_opt3')">{{ $t("message.devis_production_opt3") }}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="accessibility">{{ $t("message.devis_label_accessibility") }}</label>
                        <select id="accessibility" v-model="accessibility">
                            <option :value="$t('message.devis_accessibility_opt1')">{{ $t("message.devis_accessibility_opt1") }}</option>
                            <option :value="$t('message.devis_accessibility_opt2')">{{ $t("message.devis_accessibility_opt2") }}</option>
                        </select>
                    </div>
                    <div class="input-group">
                        <label for="specific-remarks">{{ $t("message.devis_label_specific_remarks") }}</label>
                        <input id="specific-remarks" type="text" v-model="specific_remarks" class="field" />
                    </div>

                    <div class="title-2">{{ $t("message.devis_option") }}</div>
                    <div class="input-group">
                        <label for="atmosphere">{{ $t("message.devis_label_atmosphere") }}</label>
                        <input id="atmosphere" type="text" v-model="atmosphere" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="environment">{{ $t("message.devis_label_graphical_environment") }}</label>
                        <input id="environment" type="text" v-model="environment" class="field" />
                    </div>
                    <div class="input-group">
                        <label for="remarks">{{ $t("message.devis_label_remark") }}</label>
                        <textarea id="remarks" v-model="remarks" class="field"></textarea>
                    </div>

                    <div class="grp-btn">
                        <div v-if="sendMailOK" id="msg-mail-ok">
                            <IconValid color="#0093ff" />
                            <span>{{ $t("message.send_mail_ok") }}</span>
                        </div>

                        <div v-if="sendMailKO" id="msg-mail-ko">
                            <Error color="#ff0000" />
                            <span>{{ $t("message.send_mail_ko") }}</span>
                        </div>

                        <button type="submit" :class="{ 'in-progress': sendEstimateInProgress }" :disabled="sendEstimateInProgress">
                            <Spinner color="#dd0000" v-if="sendEstimateInProgress" style="height: 23px" />
                            <span v-if="!sendEstimateInProgress">
                                <span>{{ $t("message.devis_btn") }}</span>
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import IconValid from "./img/Valid.vue";
import Spinner from "./img/Spinner.vue";
import Error from "./img/Error.vue";

export default {
    name: "Estimate",
    data() {
        return {
            name: "",
            email: "",
            phone: "",

            title: "",
            duration: "",
            objective: "",
            target: "",
            modality: "",
            people_targeted: "",
            delivery_method: "",
            start_date: "",
            number_of_modules: "",

            language: "",
            additional_language: "",
            needs: "",

            technical: "",
            supports: "",
            browsers: "",
            others: "",

            level: "",
            accessibility: "",
            specific_remarks: "",

            atmosphere: "",
            environment: "",
            remarks: "",

            sendEstimateInProgress: false,
            sendMailOK: false,
            sendMailKO: false,
        };
    },
    components: {
        IconValid,
        Spinner,
        Error,
    },
    mounted() {
        const lkContact = document.querySelector(".lk-contact");
        if (lkContact) {
            lkContact.addEventListener("click", (e) => {
                e.preventDefault();
                const el = document.getElementById("contact");
                if (el) {
                    const y = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
                this.$store.dispatch("app/displayModal", { display: false });
            });
        }
    },
    methods: {
        sendEstimate() {
            this.sendEstimateInProgress = true;

            const fd = new FormData();

            // Champs texte
            ["name", "email", "phone", "title", "duration", "objective", "target", "modality", "people_targeted", "delivery_method", "start_date", "number_of_modules", "language", "additional_language", "needs", "technical", "supports", "browsers", "others", "level", "accessibility", "specific_remarks", "atmosphere", "environment", "remarks"].forEach(
                (field) => {
                    fd.append(field, this[field]);
                }
            );

            // Radios
            const voiceover = document.querySelector('input[name="voiceover"]:checked');
            if (voiceover) fd.append("voiceover", voiceover.value);

            const video = document.querySelector('input[name="video"]:checked');
            if (video) fd.append("video", video.value);

            // Fichier
            const fileInput = document.querySelector('input[name="file"]');
            if (fileInput && fileInput.files.length > 0) {
                fd.append("file", fileInput.files[0]);
            }

            const handleResponse = (ok) => {
                this.sendEstimateInProgress = false;
                this.sendMailOK = ok;
                this.sendMailKO = !ok;

                if (ok) {
                    // Réinitialisation des champs texte
                    Object.keys(this.$data).forEach((key) => {
                        if (typeof this[key] === "string") this[key] = "";
                    });

                    // Réinitialisation manuelle du champ number
                    this.duration = null;

                    // Réinitialisation des radios et du fichier
                    document.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = false));
                    if (fileInput) fileInput.value = null;
                }

                setTimeout(() => {
                    this.sendMailOK = false;
                    this.sendMailKO = false;
                }, 3000);
            };

            // reCAPTCHA
            grecaptcha.ready(() => {
                grecaptcha.execute("6Ldv7M8ZAAAAAMNQMUrYx7g4uMQ3iaQmvwAqwFiR", { action: "estimate" }).then((token) => {
                    if (token) {
                        fd.append("recaptcha_response", token);

                        fetch("./estimate.php", {
                            method: "POST",
                            body: fd,
                        })
                            .then((res) => res.json())
                            .then((data) => {
                                handleResponse(data.success === true);
                            })
                            .catch((err) => {
                                console.error("Erreur :", err);
                                handleResponse(false);
                            });
                    } else {
                        handleResponse(false);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#estimate {
    max-width: 1400px;
    padding: 3rem 0;
    margin: auto;

    > div {
        max-width: 1000px;
        margin: auto;

        > div {
            font-size: 1.2rem;
            margin-bottom: 2rem;
            font-weight: 300;

            .main-title {
                font-size: 2.4rem;
                font-weight: 600;
                color: #333;
                margin-bottom: 2rem;
                text-align: center;
            }

            > span > span {
                color: red;
            }
        }

        .grp-btn {
            text-align: right;
            margin-top: 2rem;

            button {
                font-family: "Oswald", sans-serif;
                color: #fff;
                font-size: 1.2rem;
                border: 0;
                outline: none;
                background-color: #f90000;
                border-radius: 0.5em;
                width: auto;
                transition: 0.5s;
                font-weight: 400;
                cursor: pointer;
                padding: 0.5rem 3rem;
                box-sizing: border-box;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 0 0;
                border: 1px solid #fff;
            }
        }

        button.submit {
            background-color: #f90000;
            color: #fff;
            font-size: 1.1rem;
            border: none;
            border-radius: 0.5rem;
            padding: 0.75rem 2rem;
            cursor: pointer;
            transition: background 0.3s ease, transform 0.2s;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

            &:hover {
                background-color: #d40000;
                transform: translateY(-2px);
            }
        }

        .info {
            font-size: 1rem;
            font-weight: 300;
            color: #555;
            margin-bottom: 0.5rem;
        }

        .title-2 {
            font-size: 1.4rem;
            color: #d40000;
            margin: 2rem 0 1rem;
        }

        .input-group {
            display: flex;
            flex-direction: column;
            margin-bottom: 1.5rem;

            label {
                font-size: 1rem;
                font-weight: 400;
                margin-bottom: 0.5rem;
                color: #333;
            }

            input,
            select,
            textarea {
                font-size: 1rem;
                padding: 0.75rem 1rem;
                border-radius: 0.6rem;
                border: 1px solid #ccc;
                background: #fff;
                transition: border 0.3s ease, box-shadow 0.3s ease;

                &:focus {
                    outline: none;
                    border-color: #f90000;
                    box-shadow: 0 0 0 3px rgba(249, 0, 0, 0.2);
                }
            }

            textarea {
                resize: vertical;
                min-height: 150px;
            }

            &.required label::after {
                content: " *";
                color: red;
                font-weight: 600;
            }

            .chk {
                flex-direction: row;
                align-items: center;
                gap: 1rem;
                margin-top: 0.5rem;

                label {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    #msg-mail-ko,
    #msg-mail-ok {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;
        z-index: 1;

        svg {
            height: auto;
            width: 2rem;
            margin-right: 1rem;
        }

        span {
            font-size: 1.2rem;
            color: #707070;
            font-weight: 700;
        }
    }
}
</style>
